import { get } from "utilities/network";

export const httpGetVendor = () => {
  return get("vendor/auth/me");
};
